export default "__VITE_ASSET__icQEB8PL__"